import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Dialog, IconButton } from 'react-toolbox';
import { connect } from 'react-redux';
import LocationInfo from 'repairInspection/locationInfo';
import ConcernsAndResults from 'repairInspection/concernsAndResults';
import MaterialsNeeded from 'repairInspection/materialsNeeded';
import S from 'modal.scss';
import Loading from 'components/Loading';
import styles from 'styles/input.scss';
import {
  clearValidation, repairInspectionReportCreate, updatePhaseTask,
} from 'actionCreators';
import PhaseType from 'types/phase';

class RepairInspectionModal extends Resetter(Validator(React.Component)) {
  static DEFAULT_STATE = {
    installerName: '',
    inspectorName: '',
    inspectionType: '',
    subfloorType: '',
    moisture: '',
    petsPresent: '',
    cleaningPractices: '',
    customerConcerns: '',
    inspectionResults: '',
    locationOfConcern: '',
    materialsLeftOver: '',
    materialsNeeded: [],
    errors: {},
    tab: 1,
  }

  static VALIDATIONS = { installerName: true, customerName: true, inspectorName: true };

  handleClose() {
    super.handleClose();
    this.props.clearValidation();
    document.location.reload();
  }

  updateFormData = (repairInspectionData) => {
    const { inspectionType, subfloorType, moisture, petsPresent, cleaningPractices,
      customerConcerns, inspectorName, installerName, inspectionResults,
      locationOfConcern, materialsLeftOver, materialsNeeded } = this.state;
    const { id, customer_name, surface_type: { name }, store: { number },
            project_number, wo_source = '' } = this.props.phase;
    this.setState(repairInspectionData, () => {
      if (repairInspectionData.tab === 4) {
        this.props.repairInspectionReportCreate({
          installer_name: installerName,
          inspector_name: inspectorName,
          inspection_type: inspectionType,
          subfloor_type: subfloorType,
          moisture,
          pets_present: petsPresent,
          cleaning_practices: cleaningPractices,
          customer_concerns: customerConcerns,
          inspection_results: inspectionResults,
          location_of_concern: locationOfConcern,
          materials_left_over: materialsLeftOver,
          materials_needed: materialsNeeded,
          customer_name,
          surface_type: name,
          store_number: number,
          project_number,
          phase_id: id,
          work_order_type: wo_source || 'N/A',
        }).then(() => this.handleClose()).catch(() => { });
      }
    });
  }

  showTab = () => {
    const { inspectionType, subfloorType, moisture, petsPresent, cleaningPractices,
            customerConcerns, inspectorName, installerName, inspectionResults,
            locationOfConcern, materialsLeftOver, materialsNeeded, tab } = this.state;
    switch (tab) {
      case 1:
        return (<LocationInfo
          updateFormData={this.updateFormData}
          inspectionType={inspectionType}
          subfloorType={subfloorType}
          moisture={moisture}
          petsPresent={petsPresent}
          cleaningPractices={cleaningPractices}
        />);
      case 2:
        return (<ConcernsAndResults
          updateFormData={this.updateFormData}
          customerConcerns={customerConcerns}
          inspectorName={inspectorName}
          installerName={installerName}
          inspectionResults={inspectionResults}
          locationOfConcern={locationOfConcern}
          materialsLeftOver={materialsLeftOver}
        />);
      case 3:
        return (<MaterialsNeeded
          updateFormData={this.updateFormData}
          materialsNeeded={materialsNeeded}
        />);
      default:
        return (<Loading />);
    }
  }

  render = () => (<Dialog
    active={this.props.active} className={S.modal} type="fullscreen"
    onEscKeyDown={this.handleClose} onOverlayClick={this.handleClose}
  >
    <div className={styles.errored}>
      {Object.keys(this.props.errors).length > 0 &&
        <span className={styles.error}>This action could not be completed.</span>}
    </div>
    <IconButton icon="close" className={S.close} onClick={this.handleClose} />
    <h5>Workorder Inspection Report</h5>
    {this.showTab()}
  </Dialog>);
}

RepairInspectionModal.propTypes = {
  active: PropTypes.bool.isRequired,
  clearValidation: PropTypes.func.isRequired,
  repairInspectionReportCreate: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  phase: PhaseType.isRequired,
  errors: PropTypes.shape({
    name: PropTypes.arrayOf(PropTypes.string),
  }),
};

RepairInspectionModal.defaultProps = { active: false };

export default connect(state => ({ errors: state.repairInspectionReport.uploadError }), {
  clearValidation, repairInspectionReportCreate, updatePhaseTask,
})(RepairInspectionModal);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/repairInspectionModal.jsx